const aiRewrite = (color = "currentColor") => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 26 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="13"
				cy="13.5"
				r="12"
				fill="url(#paint0_linear_646_11063)"
			/>
			<circle
				cx="13"
				cy="13.5"
				r="12.3"
				stroke={color}
				stroke-opacity="0.05"
				stroke-width="0.6"
			/>
			<g filter="url(#filter0_ddi_646_11063)">
				<path
					d="M16.3231 11.4122C16.2837 11.4122 16.2503 11.4043 16.2227 11.3886C16.1952 11.3729 16.1735 11.3453 16.1578 11.306L15.8154 10.5039L14.9534 10.1264C14.914 10.1107 14.8865 10.0891 14.8707 10.0616C14.855 10.034 14.8471 10.0006 14.8471 9.96131C14.8471 9.92199 14.855 9.88857 14.8707 9.86104C14.8865 9.83352 14.914 9.8119 14.9534 9.79617L15.8154 9.4305L16.1578 8.66378C16.1735 8.62446 16.1952 8.59694 16.2227 8.58121C16.2503 8.56548 16.2837 8.55762 16.3231 8.55762C16.3625 8.55762 16.3959 8.56548 16.4235 8.58121C16.451 8.59694 16.4727 8.62446 16.4884 8.66378L16.8308 9.4305L17.6928 9.79617C17.7322 9.8119 17.7597 9.83352 17.7755 9.86104C17.7912 9.88857 17.7991 9.92199 17.7991 9.96131C17.7991 10.0006 17.7912 10.034 17.7755 10.0616C17.7597 10.0891 17.7322 10.1107 17.6928 10.1264L16.8308 10.5039L16.4884 11.306C16.4727 11.3453 16.451 11.3729 16.4235 11.3886C16.3959 11.4043 16.3625 11.4122 16.3231 11.4122ZM16.3231 18.4424C16.2916 18.4424 16.2601 18.4346 16.2286 18.4188C16.1972 18.4031 16.1735 18.3756 16.1578 18.3363L15.8154 17.5695L14.9652 17.2039C14.9258 17.1882 14.8983 17.1665 14.8825 17.139C14.8668 17.1115 14.8589 17.0781 14.8589 17.0387C14.8589 16.9994 14.8668 16.966 14.8825 16.9385C14.8983 16.911 14.9258 16.8893 14.9652 16.8736L15.8154 16.5079L16.1578 15.694C16.1735 15.6547 16.1952 15.6272 16.2227 15.6115C16.2503 15.5957 16.2837 15.5879 16.3231 15.5879C16.3625 15.5879 16.3959 15.5957 16.4235 15.6115C16.451 15.6272 16.4727 15.6547 16.4884 15.694L16.8308 16.5079L17.681 16.8736C17.7204 16.8893 17.7479 16.911 17.7637 16.9385C17.7794 16.966 17.7873 16.9994 17.7873 17.0387C17.7873 17.0781 17.7794 17.1115 17.7637 17.139C17.7479 17.1665 17.7204 17.1882 17.681 17.2039L16.8308 17.5695L16.4884 18.3363C16.4727 18.3756 16.4491 18.4031 16.4176 18.4188C16.3861 18.4346 16.3546 18.4424 16.3231 18.4424ZM11.1394 16.4018C11.0764 16.4018 11.0154 16.3841 10.9564 16.3487C10.8973 16.3133 10.8521 16.2642 10.8206 16.2012L10.0531 14.5616L8.39995 13.8185C8.33698 13.7871 8.28778 13.7418 8.25235 13.6829C8.21693 13.6239 8.19922 13.5629 8.19922 13.5C8.19922 13.4371 8.21693 13.3762 8.25235 13.3172C8.28778 13.2582 8.33698 13.213 8.39995 13.1815L10.0531 12.4384L10.8206 10.8106C10.8521 10.7398 10.8973 10.6867 10.9564 10.6514C11.0154 10.616 11.0764 10.5983 11.1394 10.5983C11.2024 10.5983 11.2634 10.616 11.3224 10.6514C11.3815 10.6867 11.4267 10.7359 11.4582 10.7988L12.2375 12.4384L13.8789 13.1815C13.9497 13.213 14.0028 13.2582 14.0383 13.3172C14.0737 13.3762 14.0914 13.4371 14.0914 13.5C14.0914 13.5629 14.0737 13.6239 14.0383 13.6829C14.0028 13.7418 13.9497 13.7871 13.8789 13.8185L12.2375 14.5616L11.4582 16.2012C11.4267 16.272 11.3815 16.3231 11.3224 16.3546C11.2634 16.386 11.2024 16.4018 11.1394 16.4018Z"
					fill="url(#paint1_linear_646_11063)"
					shape-rendering="crispEdges"
				/>
			</g>
			<defs>
				<filter
					id="filter0_ddi_646_11063"
					x="4.37916"
					y="5.22055"
					width="16.8006"
					height="17.7444"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="-0.790357" dy="1.4929" />
					<feGaussianBlur stdDeviation="1.51485" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_646_11063"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="0.746449" dy="-0.70254" />
					<feGaussianBlur stdDeviation="1.31726" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_646_11063"
						result="effect2_dropShadow_646_11063"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_646_11063"
						result="shape"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1.84417" />
					<feGaussianBlur stdDeviation="1.16358" />
					<feComposite
						in2="hardAlpha"
						operator="arithmetic"
						k2="-1"
						k3="1"
					/>
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
					/>
					<feBlend
						mode="normal"
						in2="shape"
						result="effect3_innerShadow_646_11063"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_646_11063"
					x1="16.5745"
					y1="1.5"
					x2="16.5745"
					y2="25.5"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#D43F8C" />
					<stop offset="1" stop-color="#4038B6" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_646_11063"
					x1="14.6773"
					y1="13.2104"
					x2="13.1901"
					y2="20.124"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="white" stop-opacity="0.96" />
					<stop offset="1" stop-color="white" stop-opacity="0.23" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default aiRewrite;
